import classNames from "classnames"
import PropTypes from "prop-types"
import React from "react"

import Button from "../Button"

const MenuButton = ({
  disabled = false,
  fullWidth = false,
  hasErrors = false,
  label,
  onClick,
  open,
  variant = "secondary",
}) => {
  return (
    <Button
      variant={variant}
      onClick={onClick}
      disabled={disabled}
      fullWidth={fullWidth}
      hasErrors={hasErrors}
    >
      <span
        className={classNames("flex items-center", {
          "w-full min-w-0 justify-between": fullWidth,
        })}
      >
        <span
          className={classNames({ truncate: fullWidth })}
          title={fullWidth && typeof label === "string" ? label : undefined}
        >
          {label}
        </span>
        <i
          className={classNames("fa-solid ml-2 shrink-0", {
            "fa-chevron-up": open,
            "fa-chevron-down": !open,
          })}
        />
      </span>
    </Button>
  )
}

MenuButton.propTypes = {
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.node,
  ]).isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  hasErrors: PropTypes.bool,
  open: PropTypes.bool.isRequired,
  variant: PropTypes.oneOf([
    "primary",
    "secondary",
    "tertiary",
    "danger",
    "ghost",
    "quarternary",
  ]),
}

export default MenuButton
